// European Football Tournaments 2025/26 Season
export const EUROPEAN_TOURNAMENTS = {
  CHAMPIONS_LEAGUE: {
    name: '🏆 ჩემპიონთა ლიგა',
    season: '2025/26',
    format: '36 გუნდი - საერთო ჯგუფი (თითოეული 8 მატჩი)',
    finalDate: '2026-05-30',
    finalLocation: 'ბუდაპეშტი, პუშკაშ არენა',
    teams: [
      // ინგლისი (6 გუნდი)
      { name: 'ლივერპული', country: 'ინგლისი', confederation: 'UEFA' },
      { name: 'არსენალი', country: 'ინგლისი', confederation: 'UEFA' },
      { name: 'მანჩესტერ სიტი', country: 'ინგლისი', confederation: 'UEFA' },
      { name: 'ჩელსი', country: 'ინგლისი', confederation: 'UEFA' },
      { name: 'ტოტენჰემი', country: 'ინგლისი', confederation: 'UEFA' },
      { name: 'ნიუკასლი', country: 'ინგლისი', confederation: 'UEFA' },
      
      // იტალია (4 გუნდი)
      { name: 'ნაპოლი', country: 'იტალია', confederation: 'UEFA' },
      { name: 'ინტერი', country: 'იტალია', confederation: 'UEFA' },
      { name: 'ატალანტა', country: 'იტალია', confederation: 'UEFA' },
      { name: 'იუვენტუსი', country: 'იტალია', confederation: 'UEFA' },
      
      // ესპანეთი (5 გუნდი)
      { name: 'ბარსელონა', country: 'ესპანეთი', confederation: 'UEFA' },
      { name: 'რეალ მადრიდი', country: 'ესპანეთი', confederation: 'UEFA' },
      { name: 'ატლეტიკო მადრიდი', country: 'ესპანეთი', confederation: 'UEFA' },
      { name: 'ატლეტიკ ბილბაო', country: 'ესპანეთი', confederation: 'UEFA' },
      { name: 'ვილიარეალი', country: 'ესპანეთი', confederation: 'UEFA' },
      
      // გერმანია (4 გუნდი)
      { name: 'ბაიერნი', country: 'გერმანია', confederation: 'UEFA' },
      { name: 'ბაიერ ლევერკუზენი', country: 'გერმანია', confederation: 'UEFA' },
      { name: 'ეინტრახტ ფრანკფურტი', country: 'გერმანია', confederation: 'UEFA' },
      { name: 'ბოროუსია დორტმუნდი', country: 'გერმანია', confederation: 'UEFA' },
      
      // საფრანგეთი (3 გუნდი)
      { name: 'პარი სენ-ჟერმენი', country: 'საფრანგეთი', confederation: 'UEFA' },
      { name: 'მარსელი', country: 'საფრანგეთი', confederation: 'UEFA' },
      { name: 'AS მონაკო', country: 'საფრანგეთი', confederation: 'UEFA' },
      
      // ნიდერლანდები (2 გუნდი)
      { name: 'PSV აიндჰოვენი', country: 'ნიდერლანდები', confederation: 'UEFA' },
      { name: 'აიაქსი', country: 'ნიდერლანდები', confederation: 'UEFA' },
      
      // პორტუგალია (2 გუნდი)
      { name: 'ბენფიკა', country: 'პორტუგალია', confederation: 'UEFA' },
      { name: 'სპორტინგი', country: 'პორტუგალია', confederation: 'UEFA' },
      
      // ბელგია (2 გუნდი)
      { name: 'კლუბ ბრიუგე', country: 'ბელგია', confederation: 'UEFA' },
      { name: 'იუნიონ სენტ-ჟილოიზე', country: 'ბელგია', confederation: 'UEFA' },
      
      // თურქეთი (1 გუნდი)
      { name: 'გალათასარაი', country: 'თურქეთი', confederation: 'UEFA' },
      
      // სხვა ქვეყნები (7 გუნდი)
      { name: 'სლავია პრაღა', country: 'ჩეხეთი', confederation: 'UEFA' },
      { name: 'ბოდე/გლიმტი', country: 'ნორვეგია', confederation: 'UEFA' },
      { name: 'ოლიმპიაკოსი', country: 'საბერძნეთი', confederation: 'UEFA' },
      { name: 'კოპენჰაგენი', country: 'დანია', confederation: 'UEFA' },
      { name: 'პაფოსი', country: 'კვიპროსი', confederation: 'UEFA' },
      { name: 'ქარაბაღი', country: 'აზერბაიჯანი', confederation: 'UEFA' },
      { name: 'კაირათი', country: 'ყაზახეთი', confederation: 'UEFA' }
    ]
  },

  EUROPA_LEAGUE: {
    name: '🏅 ევროპა ლიგა',
    season: '2025/26',
    format: '36 გუნდი - საერთო ჯგუფი',
    finalDate: '2026-05-20',
    finalLocation: 'სტამბოლი, თურქეთი',
    teams: [
      // ინგლისი (2 გუნდი)
      { name: 'ასტონ ვილა', country: 'ინგლისი', confederation: 'UEFA' },
      { name: 'ნოტინგემ ფორესტი', country: 'ინგლისი', confederation: 'UEFA' },
      
      // იტალია (2 გუნდი)
      { name: 'ბოლონია', country: 'იტალია', confederation: 'UEFA' },
      { name: 'AS რომა', country: 'იტალია', confederation: 'UEFA' },
      
      // ესპანეთი (2 გუნდი)
      { name: 'რეალ ბეტისი', country: 'ესპანეთი', confederation: 'UEFA' },
      { name: 'სელტა ვიგო', country: 'ესპანეთი', confederation: 'UEFA' },
      
      // გერმანია (2 გუნდი)
      { name: 'SC ფრაიბურგი', country: 'გერმანია', confederation: 'UEFA' },
      { name: 'ფოტბალი კლუბი შტუტგარტი', country: 'გერმანია', confederation: 'UEFA' },
      
      // საფრანგეთი (3 გუნდი)
      { name: 'LOSC ლილი', country: 'საფრანგეთი', confederation: 'UEFA' },
      { name: 'Olympique Lyonnais', country: 'საფრანგეთი', confederation: 'UEFA' },
      { name: 'OGC ნიცა', country: 'საფრანგეთი', confederation: 'UEFA' },
      
      // პორტუგალია (2 გუნდი)
      { name: 'SC ბრაგა', country: 'პორტუგალია', confederation: 'UEFA' },
      { name: 'FC პორტო', country: 'პორტუგალია', confederation: 'UEFA' },
      
      // ნიდერლანდები (3 გუნდი)
      { name: 'ფეიენოორდი', country: 'ნიდერლანდები', confederation: 'UEFA' },
      { name: 'Go Ahead Eagles', country: 'ნიდერლანდები', confederation: 'UEFA' },
      { name: 'FC იუტრეხტი', country: 'ნიდერლანდები', confederation: 'UEFA' },
      
      // ავსტრია (2 გუნდი)
      { name: 'FC სალცბურგი', country: 'ავსტრია', confederation: 'UEFA' },
      { name: 'SK შტურმი გრაცი', country: 'ავსტრია', confederation: 'UEFA' },
      
      // ბელგია (1 გუნდი)
      { name: 'KAA გენკი', country: 'ბელგია', confederation: 'UEFA' },
      
      // სხვა ქვეყნები (14 გუნდი)
      { name: 'ლუდოგორეცი', country: 'ბულგარეთი', confederation: 'UEFA' },
      { name: 'დინამო ზაგრები', country: 'ხორვატია', confederation: 'UEFA' },
      { name: 'ვიქტორია პლზენი', country: 'ჩეხეთი', confederation: 'UEFA' },
      { name: 'FC მიდტიულანი', country: 'დანია', confederation: 'UEFA' },
      { name: 'პანათინაიკოსი', country: 'საბერძნეთი', confederation: 'UEFA' },
      { name: 'PAOK FC', country: 'საბერძნეთი', confederation: 'UEFA' },
      { name: 'ფერენცვაროში TC', country: 'უნგრეთი', confederation: 'UEFA' },
      { name: 'მაკაბი თელ-ავივი', country: 'ისრაელი', confederation: 'UEFA' },
      { name: 'სიერა ბრანი IL', country: 'ნორვეგია', confederation: 'UEFA' },
      { name: 'FC ფსჟ', country: 'რუმინეთი', confederation: 'UEFA' },
      { name: 'სელტიკი', country: 'შოტლანდია', confederation: 'UEFA' },
      { name: 'Rangers FC', country: 'შოტლანდია', confederation: 'UEFA' },
      { name: 'ცრვენა ზვეზდა', country: 'სერბეთი', confederation: 'UEFA' },
      { name: 'AIK მალმიო', country: 'შვედეთი', confederation: 'UEFA' },
      { name: 'FC ბაზელი', country: 'შვეიცარია', confederation: 'UEFA' },
      { name: 'Young Boys Bern', country: 'შვეიცარია', confederation: 'UEFA' },
      { name: 'ფენერბახჩე', country: 'თურქეთი', confederation: 'UEFA' }
    ]
  },

  CONFERENCE_LEAGUE: {
    name: '🎖️ კონფერენს ლიგა',
    season: '2025/26',
    format: '36 გუნდი - საერთო ჯგუფი',
    finalDate: '2026-05-13',
    finalLocation: 'მდგომარეობა დაყენდება',
    teams: [
      // ინგლისი (1 გუნდი)
      { name: 'Crystal Palace FC', country: 'ინგლისი', confederation: 'UEFA' },
      
      // იტალია (2 გუნდი)
      { name: 'ACF ფიორენტინა', country: 'იტალია', confederation: 'UEFA' },
      { name: 'SS ლაციო', country: 'იტალია', confederation: 'UEFA' },
      
      // ესპანეთი (1 გუნდი)
      { name: 'რაიო ვალიეკანო', country: 'ესპანეთი', confederation: 'UEFA' },
      
      // გერმანია (1 გუნდი)
      { name: 'TSG ჰოფენჰაიმი', country: 'გერმანია', confederation: 'UEFA' },
      
      // საფრანგეთი (1 გუნდი)
      { name: 'Stade Rennais FC', country: 'საფრანგეთი', confederation: 'UEFA' },
      
      // პორტუგალია (2 გუნდი)
      { name: 'სპორტინგი კოვილანი', country: 'პორტუგალია', confederation: 'UEFA' },
      { name: 'CF მორეირენსე', country: 'პორტუგალია', confederation: 'UEFA' },
      
      // ავსტრია (1 გუნდი)
      { name: 'SK რაპიდი ვენა', country: 'ავსტრია', confederation: 'UEFA' },
      
      // სხვა ქვეყნები (23 გუნდი)
      { name: 'სიგმა ოლომოუცი', country: 'ჩეხეთი', confederation: 'UEFA' },
      { name: 'აეკ ლარნაკა', country: 'კვიპროსი', confederation: 'UEFA' },
      { name: 'FC კოპენჰაგენი', country: 'დანია', confederation: 'UEFA' },
      { name: 'დინამო კიევი', country: 'უკრაინა', confederation: 'UEFA' },
      { name: 'ჰელას ვერონა', country: 'იტალია', confederation: 'UEFA' },
      { name: 'სამსუნსპორი AS', country: 'თურქეთი', confederation: 'UEFA' },
      { name: 'შელბოურნი FC', country: 'ირლანდია', confederation: 'UEFA' },
      { name: 'FK შკენდია', country: 'ჩრდილოეთ მაკედონია', confederation: 'UEFA' },
      { name: 'ლეგია ვარშავა', country: 'პოლონეთი', confederation: 'UEFA' },
      { name: 'იაგელონია ბიალისტოკი', country: 'პოლონეთი', confederation: 'UEFA' },
      { name: 'AS Слован Bratislava', country: 'სლოვაკეთი', confederation: 'UEFA' },
      { name: 'უნივერსიტატეა კრაიოვა', country: 'რუმინეთი', confederation: 'UEFA' },
      { name: 'FK დრიტა', country: 'კოსოვო', confederation: 'UEFA' },
      { name: 'Ħamrun Spartans', country: 'მალტა', confederation: 'UEFA' },
      { name: 'HJK ჰელსინკი', country: 'ფინეთი', confederation: 'UEFA' },
      { name: 'FK არაზი ნახჩივანი', country: 'აზერბაიჯანი', confederation: 'UEFA' },
      { name: 'GIO-ს კრებული', country: 'უნგრეთი', confederation: 'UEFA' },
      { name: 'FK ღეოვანი', country: 'ჯორჯია', confederation: 'UEFA' },
      { name: 'მოლდოვა FC', country: 'მოლდოვა', confederation: 'UEFA' },
      { name: 'FK რიელი', country: 'ბელარუსი', confederation: 'UEFA' },
      { name: 'FK ზალგირის', country: 'ლიტვა', confederation: 'UEFA' },
      { name: 'ფს მეტალის', country: 'ესტონეთი', confederation: 'UEFA' }
    ]
  }
};

// Tournament Finals Information
export const TOURNAMENT_FINALS = {
  championsLeague: {
    name: '🏆 ჩემპიონთა ლიგის ფინალი',
    date: '2026-05-30',
    location: 'ბუდაპეშტი',
    stadium: 'პუშკაშ არენა',
    country: 'უნგრეთი',
    capacity: 67889
  },
  europaLeague: {
    name: '🏅 ევროპა ლიგის ფინალი',
    date: '2026-05-20',
    location: 'სტამბოლი',
    stadium: 'ოლიმპიას კი',
    country: 'თურქეთი',
    capacity: 76092
  },
  conferenceLEague: {
    name: '🎖️ კონფერენს ლიგის ფინალი',
    date: '2026-05-13',
    location: 'მდგომარეობა დაუსახელებელი',
    stadium: 'დაიდგება მოგვიანებით',
    country: '',
    capacity: null
  }
};
